import { render, staticRenderFns } from "./ParagraphPublications.vue?vue&type=template&id=400dcf67&"
import script from "./ParagraphPublications.vue?vue&type=script&lang=js&"
export * from "./ParagraphPublications.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphPublications.vue?vue&type=style&index=0&id=400dcf67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports